import { Redirect, Route, Switch } from 'react-router-dom'

import { Edit } from './edit'
import { Page as List } from './page'

// currently the /new/* route will redirect to /app/admin/managed_event_types/new
export const ManagedEventTypesRoutes = ({ match }) => (
  <Switch>
    <Route path={`${match.url}`} exact component={List} />
    <Route path={`${match.url}/:id/(edit|assign)`} component={Edit} />
    <Redirect from={`${match.url}/new`} to={`${match.url}?new=true`} exact />
  </Switch>
)
